import React from "react";
import trans from "../../../../utils";
import { InputDate } from "../../../Helpers/Input/Input";
import { InputSelect } from "../../../Helpers/Input/RefactoredInput";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";

export default function IROfflineFormInformation({
  formBody,
  formEditData,
  addData,
  setRoomId,
}) {
  console.log("FOrmeditdata", formEditData);
  console.log("setRoom", setRoomId);
  const params = useParams();
  return (
    <div style={{ paddingInline: "16px", overflowY: "auto" }}>
      <p className="fs-16 fw-500 brand-700 text-capitalize">
        {trans("general information")}
      </p>
      <div className="row gy-2">
        <div className="col-lg-12">
          <InputSelect
            label="projects"
            name="project_id"
            id="project_id"
            options={[
              {
                label: formBody?.project?.name,
                value: formBody?.project?.id,
              },
            ]}
            value={
              !params?.id ? formBody?.project?.id : formEditData?.project_id
            }
            disabled={true}
          />
        </div>
        <div className="col-lg-12">
          <InputSelect
            label="Building"
            name="zone_id"
            id="zone_id"
            options={[
              {
                label: formBody?.building?.name,
                value: formBody?.building?.id,
              },
            ]}
            value={!params?.id ? formBody?.building?.id : formEditData?.zone_id}
            disabled={true}
          />
        </div>
        <div className="col-lg-12">
          <InputSelect
            label="level"
            name="level_id"
            id="level_id"
            options={[
              {
                label: formBody?.level?.name,
                value: formBody?.level?.id,
              },
            ]}
            value={!params?.id ? formBody?.level?.id : formEditData?.level_id}
            disabled={true}
          />
        </div>
        <div className="col-lg-12">
          <InputSelect
            label="Space"
            name="room_id"
            id="room_id"
            options={formBody?.rooms?.map((i) => ({
              label: i?.displayName,
              value: i?.poiId,
            }))}
            onBlur={(e) => addData.handleBlur(e)}
            onChange={(value) => {
              addData.setFieldValue("room_id", value);
              setRoomId(value);
              const roomLabel = formBody?.rooms?.find(
                (i) => i?.poiId === value,
              )?.displayName;
              addData.setFieldValue("room_name", roomLabel);
            }}
            value={addData.values.room_id || undefined}
            allowClear={false}
            touched={addData.touched.room_id}
            errors={addData.errors.room_id}
            placeholder={trans("Select Space")}
            // value={formBody?.project?.id}
          />
        </div>
        <div className="col-lg-6">
          <InputSelect
            label="discipline"
            name="discipline"
            id="discipline"
            options={formBody?.modules
              ?.filter((j) => j.module === "IR")
              ?.map((i) => ({
                label: i?.discipline,
                value: i?.discipline,
              }))}
            value={
              !params?.id
                ? trans(
                    `${
                      formBody?.modules
                        ?.filter((j) => j.module === "IR")
                        ?.map((i) => {
                          return i.discipline;
                        })?.[0]
                    }`,
                  )
                : trans(formEditData?.discipline)
            }
            disabled={true}
          />
        </div>
        <div className="col-lg-6">
          <InputSelect
            label="form"
            name="form_id"
            options={formBody?.formSchemas?.map((i) => ({
              label: i?.name,
              value: i?.id,
            }))}
            value={formBody?.modules
              ?.filter((j) => j.module === "IR")
              ?.map((i) => {
                return i.formId;
              })}
            disabled={true}
          />
        </div>
        <div className="col-lg-12">
          <InputDate
            title={trans("Ready Date")}
            id="ready_date"
            name="ready_date"
            formstyle="h-0"
            onBlur={(value) => addData.setFieldTouched("ready_date", true)}
            onChange={(value) => {
              const formattedDate = value
                ? dayjs(value).format("YYYY-MM-DD")
                : "";
              addData.setFieldValue("ready_date", formattedDate);
            }}
            errors={addData.errors.ready_date}
            touched={addData.touched.ready_date}
            value={addData.values.ready_date || ""}
            min={dayjs(Date.now()).add(1, "day")}
          />
        </div>
      </div>

      {/* Location Selector Modal */}
    </div>
  );
}
